const Style = {
    wrapper: 'space-y-1.5',
    label: 'text-xs font-medium text-text-secondary',

    // Ten equal columns rather than flex-wrap: the ramp only reads as a ramp
    // when the stops stay in one row at every width.
    ramp: 'grid grid-cols-10 overflow-hidden rounded-md border border-border',
    swatch: 'flex h-10 items-center justify-center',
    sample: 'text-[10px] font-semibold text-white',

    scale: 'grid grid-cols-10',
    step: 'text-center text-[10px] tabular-nums text-text-muted',
};

export default Style;
